import union from "@turf/union";
import hasFeature from "src/js/stores/user/actions/hasFeature";
import Feature from "src/js/stores/user/Feature";

interface SearchableCountry {
  feature: Feature;
  geojson: GeoJSON.Feature<
    GeoJSON.Polygon,
    {
      googleSearchRegion: string;
    }
  >;
}

const searchCountries: SearchableCountry[] = [
  {
    feature: Feature.ukLocationSearch,
    geojson: {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-11.597436, 49.055502],
            [1.761938, 49.055502],
            [1.761938, 61.071302],
            [-11.597436, 61.071302],
            [-11.597436, 49.055502],
          ],
        ],
      },
      properties: {
        googleSearchRegion: "gb",
      },
    },
  },
  {
    feature: Feature.usLocationSearch,
    geojson: {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-124.736342, 24.521208],
            [-66.945392, 24.521208],
            [-66.945392, 49.382808],
            [-124.736342, 49.382808],
            [-124.736342, 24.521208],
          ],
        ],
      },
      properties: {
        googleSearchRegion: "us",
      },
    },
  },
];

export function getSearchAreas() {
  const isPublic = !hasFeature(Feature.ukLocationSearch) && !hasFeature(Feature.usLocationSearch);
  return searchCountries
    .filter(({ feature }) => isPublic || hasFeature(feature))
    .map(({ geojson }) => geojson)
    .reduce<{
      countries: string[];
      geometry: GeoJSON.Feature<GeoJSON.Polygon | GeoJSON.MultiPolygon>;
    }>(
      (acc, geojson) => {
        return {
          countries: [...acc.countries, geojson.properties.googleSearchRegion],
          geometry: union(acc.geometry as GeoJSON.Feature<GeoJSON.Polygon>, geojson) as GeoJSON.Feature<
            GeoJSON.Polygon | GeoJSON.MultiPolygon
          >,
        };
      },
      {
        countries: [],
        geometry: {
          type: "Feature",
          properties: {},
          geometry: {
            type: "Polygon",
            coordinates: [[]],
          },
        },
      }
    );
}
